export default {
  get: function(){
    return {
      api:{
        get:{
          fetching: false,
          error: false,
          values: [],
        },
        put: {

        },
        post:{

        },
        delete:{

        }
      }
    }
  }
}
